     <table class="tabela-financiamento rounded-sm sm-shadow p-4">
        <thead>
          <tr>
            <th scope="col" class="p-4 text-start border-bottom">
              Etapa/Modalidade
            </th>
            <th scope="col" class="p-4 text-center border-bottom">
              Área Localidade
            </th>
            <th scope="col" class="p-4 text-center border-bottom">
              Turno
            </th>
            <th scope="col" class="p-4 text-end border-bottom">
                Valor CAQ {{descricaoFiltroFinanciamentoSelecionado}} (mediana - R$, 2026)
            </th>
            <th scope="col" class="p-4 text-end border-bottom">
              Quantidade Matrículas (2025)
            </th>
            <th scope="col" class="p-4 text-end border-bottom">
              Quantidade Escolas (2025)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let linha of filtrosLinhasTabela; let i = index; trackBy: trackByLinhaTabela">
            <!-- Etapa -->
            <td
              *ngIf="showEtapaCell(i,linha)"
              class="p-3 px-7 text-start " [class]=" linha.etapa===6 ? [] : borderBottomDaLinha(linha)"
              [attr.rowspan]="rowspanEtapaTabela(linha)"
            >
              {{ linha.etapaLabel }}
            </td>

            <!-- Localidade -->
            <td
              *ngIf="showLocalidadeCell(i,linha)"
              class="p-3 text-center " [class]="borderBottomDaLinha(linha)"
              [attr.rowspan]="linha.etapa===6 ? 1 : turnosTabela.length"
            >
              {{ linha.localidadeLabel }}
            </td>

            <!-- Turno -->
            <td class="p-3 text-center " [class]="borderBottomDaLinha(linha)">
              {{ linha.turnoLabel }}
            </td>

            <!-- Valor CAQ -->
            <td class="p-3 text-end " [class]="borderBottomDaLinha(linha)">
              <div class="flex flex-row w-full gap-4 items-center">
                <div class="relative div-caq-projecao-total-instituicao">
                  <div
                    [style.width.px]="calcularLarguraBarraCAQCategorizada(linha.etapa, linha.ehParcial, isRuralLinha(linha))"
                    [class]="linha.barraClass"
                  ></div>
                </div>

                <span class="absolute texto-caq-projecao-valor">
                  {{ obterValorCAQCategorizada(linha.etapa, linha.ehParcial, isRuralLinha(linha)) }}
                </span>
              </div>
            </td>

            <!-- Matrículas -->
            <td class="p-3 text-end " [class]="borderBottomDaLinha(linha)">
              {{ obterNumeroMatriculasCategorizada(linha.etapa, linha.ehParcial, isRuralLinha(linha)) }}
            </td>

            <!-- Escolas -->
            <td class="p-3 text-end " [class]="borderBottomDaLinha(linha)">
              {{ obterNumeroEscolasCategorizada(linha.etapa, linha.ehParcial, isRuralLinha(linha)) }}
            </td>
          </tr>
        </tbody>
      </table>
